export const DISCLOSURE_UNFINISHED = 0
export const DISCLOSURE_REQUESTED = 1
export const DISCLOSURE_COMPLETED = 2

export const SEND_FAILED = 1
export const SEND_DELIVERED = 2
export const SEND_OPENED = 3
